import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import BaseModal from '../types/Base';
import {_openModal, _removeModal} from '../../../store';
import {Icon, Row} from '../../../index';
import lazy from 'lazy.js';
import Column from '../../Column';
import SectionTitle from '../../SectionTitle';
import DescriptiveText from '../../DescriptiveText';

// TODO copied from Table icons key. Correct? Centralize? Maybe ETODO
const _IconTitle = styled.div`
  color: ${props => props.color};
`;

const IconsKeyModal = ({content, removeModal}) => {
  const {iconsKey, title} = content;
  const cols = React.useMemo(() => lazy(iconsKey).groupBy('category').pairs().toArray(), [iconsKey]);

  return <BaseModal onClose={() => removeModal(content)}
                    title={title || 'Icons and Descriptions'}
                    size={cols.length > 2 ? 'lg' : 'md'}>
    <Row wrap={true} showDividers={true} alignItems={'top'}>
      {cols.map(col => <Column key={col[0]} width={'200px'} layout={{grow: 1}}>
        {col[0] && <SectionTitle title={col[0]}/>}
        {col[1].map(icon => <Row key={icon.title}>
          <>
            <Row justifySubRow={'left'}>
              <Icon svg={icon.image} color={icon.color} description={icon.description} width={'25px'} height={'25px'}/>
              <_IconTitle color={icon.color}>{icon.title}</_IconTitle>
            </Row>
            <DescriptiveText alignment={'left'}>
              {icon.description}
            </DescriptiveText>
          </>
        </Row>)}
      </Column>)}
    </Row>
  </BaseModal>;
};

const mapStateToProps = state => ({
  session: state.session,
  product: state.product,
});

const mapDispatchToProps = dispatch => ({
  removeModal: modal => dispatch(_removeModal(modal)),
  openModal: modal => dispatch(_openModal(modal)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IconsKeyModal);

IconsKeyModal.propTypes = {
  session: PropTypes.object,
  product: PropTypes.object.isRequired,
  removeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  content: PropTypes.shape({
    /**
     * Optional Title, defaults to 'Icons and Descriptions'
     */
    title: PropTypes.string,
    iconsKey: PropTypes.arrayOf(
      PropTypes.shape({
        /**
         * Icon svg name (or link)
         */
        image: PropTypes.string.isRequired,
        /**
         * Icon title
         */
        title: PropTypes.string.isRequired,
        /**
         * Color associated with the icon
         */
        color: PropTypes.string.isRequired,
        /**
         * Icon description. If a function, receives the row and table instance when being rendered in a row via display condition.
         */
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
        /**
         * Icon category name (if applicable)
         */
        category: PropTypes.string,
      })
    ),
  }).isRequired,
};
